/*
*
* File JS componente Gallery Overflow
*
*/


import ScrollMagic from 'scrollmagic';
// import 'debug.addIndicators';

// IMPORT MODULES
//----------------------------------------------------------------------------//

// import HorizontalGallery from "../../js/plugins/im-horizontal-gallery";


// IMPORT SCSS PER LA COMPILAZIONE
//----------------------------------------------------------------------------//

import './gallery-overflow.scss';

//----------------------------------------------------------------------------//


// EXPORT COMPONENTE
//----------------------------------------------------------------------------//


const galleryOverflow = () =>
{
    // const imageGallery = new HorizontalGallery('.gallery-overflow');

    const allImagesGallery = document.querySelectorAll('.gallery-overflow');

    if(!allImagesGallery.length) return;
    
    allImagesGallery.forEach(el => {

        const allImagesBlock = el.querySelectorAll('.gallery-overflow__item');
        
        if(!allImagesBlock) return;

        let maxWidthContent = 0;
        let lastWidthItem = 0;

        allImagesBlock.forEach(inEl => {
            maxWidthContent = maxWidthContent + inEl.offsetWidth;
            lastWidthItem = inEl.offsetWidth;
        });

        const controller = new ScrollMagic.Controller();

        const scene = new ScrollMagic.Scene({
            triggerHook: 1,
            triggerElement: el,
            duration: (window.innerHeight * 1.7)
        })
        .on("progress", function (e) {
            el.querySelector('.gallery-overflow__wrapper').scroll({
                // left: ((maxWidthContent - (lastWidthItem * 1.2)) * e.progress),
                left: ((maxWidthContent - (lastWidthItem * 1.8)) * e.progress),
                top: 0,
            });
        })
        // .addIndicators()
        .addTo(controller);
    });
}

export default galleryOverflow;

//----------------------------------------------------------------------------//